import React, { useEffect, useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { notificationSettingsState } from '@atom/setting/notification';

export function NotificationPermissionManager() {
    const [notificationSettings, setNotificationSettings] = useRecoilState(notificationSettingsState);

    // 브라우저 알림 권한 요청
    const requestNotificationPermission = useCallback(async () => {
        if ('Notification' in window) {
            try {
                const permission = await Notification.requestPermission();
                console.log('알림 권한:', permission);

                // 권한이 거부된 경우 시스템 알림 비활성화
                if (permission === 'denied') {
                    setNotificationSettings(prev => ({
                        ...prev,
                        systemNotification: false
                    }));
                }
            } catch (error) {
                console.warn('알림 권한 요청 실패:', error);
            }
        }
    }, [setNotificationSettings]);

    // 오디오 자동재생 권한 확인 및 사용자 상호작용 등록
    const initializeAudioPermission = useCallback(() => {
        const handleFirstInteraction = () => {
            // 사용자의 첫 상호작용 시 오디오 컨텍스트 활성화
            const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
            if (audioContext.state === 'suspended') {
                audioContext.resume();
            }

            // 이벤트 리스너 제거 (한 번만 실행)
            document.removeEventListener('click', handleFirstInteraction);
            document.removeEventListener('keydown', handleFirstInteraction);
        };

        document.addEventListener('click', handleFirstInteraction);
        document.addEventListener('keydown', handleFirstInteraction);
    }, []);

    useEffect(() => {
        // 컴포넌트 마운트 시 권한 확인 및 초기화
        if (notificationSettings.systemNotification) {
            requestNotificationPermission();
        }

        initializeAudioPermission();
    }, [requestNotificationPermission, initializeAudioPermission, notificationSettings.systemNotification]);

    // 이 컴포넌트는 UI를 렌더링하지 않음 (시스템 관리용)
    return null;
}

// 알림 설정을 위한 유틸리티 함수들 export
export const notificationUtils = {
    // 알림 권한 상태 확인
    getPermissionStatus: () => {
        if ('Notification' in window) {
            return Notification.permission;
        }
        return 'unsupported';
    },

    // 알림 권한 요청
    requestPermission: async () => {
        if ('Notification' in window) {
            return await Notification.requestPermission();
        }
        return 'unsupported';
    },

    // 테스트 알림 표시
    showTestNotification: () => {
        if ('Notification' in window && Notification.permission === 'granted') {
            new Notification('테스트 알림', {
                body: '알림이 정상적으로 작동합니다.',
                icon: '/favicon.ico',
                tag: 'test-notification',
            });
        }
    }
}; 